module.exports = __webpack_public_path__ + "img/批量重新推送.7d7e1875.svg";